import * as React from "react"

function CustomerAdviser
(props) {
  return (
    <svg
      viewBox="0 0 45 45"
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit={2}
      {...props}
    >
      <circle
        cx={203.698}
        cy={125.424}
        r={70.298}
        fill="#e5eeff"
        transform="matrix(.3174 0 0 .3174 -42.342 -17.497)"
      />
      <path
        d="M28.524 27.154a.64.64 0 00-.914 0c-2.922 2.923-7.709 2.923-10.668 0a.64.64 0 00-.913 0 .64.64 0 000 .914 8.827 8.827 0 006.247 2.594c2.265 0 4.53-.877 6.248-2.594.256-.256.256-.695 0-.914zM17.198 21.199c.767 0 1.388.256 1.388 1.023 0 .365.292.658.658.658a.655.655 0 00.657-.658c0-1.462-1.205-2.302-2.667-2.302-1.461 0-2.667.84-2.667 2.302 0 .365.292.658.658.658a.655.655 0 00.657-.658c-.073-.767.549-1.023 1.316-1.023zM26.259 22.222c0-.767.62-1.023 1.388-1.023.767 0 1.388.256 1.388 1.023 0 .365.293.658.658.658a.655.655 0 00.658-.658c0-1.462-1.206-2.302-2.667-2.302-1.462 0-2.668.84-2.668 2.302 0 .365.293.658.658.658.365 0 .585-.293.585-.658z"
        fill="#052879"
        fillRule="nonzero"
      />
      <path
        d="M38.06 21.235h-2.046l.877-.657c.182-.11.255-.329.255-.512 0-7.928-6.613-14.395-14.724-14.395h-.073c-8.147 0-14.76 6.467-14.76 14.395 0 .183.11.402.256.512l.84.657H6.602a2.292 2.292 0 00-2.301 2.302v4.713a2.292 2.292 0 002.301 2.302l3.91-.036c.365 0 .62-.293.62-.658v-8.55c0-6.174 5.006-11.18 11.18-11.216 6.175.037 11.18 5.042 11.18 11.217v8.512c0 .366.293.621.622.658h.95c-.33 3.142-2.887 5.663-6.065 5.882a1.95 1.95 0 00-1.827-1.279h-1.863a1.95 1.95 0 00-1.937 1.937 1.95 1.95 0 001.937 1.936h1.863c.84 0 1.571-.548 1.827-1.315 3.873-.22 7.015-3.288 7.307-7.161h1.717a2.292 2.292 0 002.302-2.302v-4.676c.036-1.243-.987-2.266-2.265-2.266zM27.209 37.677h-1.864a.655.655 0 01-.657-.658c0-.365.292-.658.657-.658h1.864c.365 0 .657.293.657.658a.655.655 0 01-.657.658zM9.854 29.2l-3.288.037a.982.982 0 01-.987-.987V23.5c0-.547.439-.986.987-.986h3.288V29.2zM22.422 8.813h-.146C15.7 8.886 10.33 14.038 9.927 20.505l-1.023-.768c.146-7.05 6.102-12.75 13.409-12.75h.073c7.307 0 13.262 5.7 13.445 12.75l-1.096.804c-.365-6.503-5.736-11.655-12.313-11.728zm16.66 19.4a.982.982 0 01-.986.987l-3.288-.036v-6.65h3.288c.548 0 .987.439.987.987v4.713z"
        fill="#052879"
        fillRule="nonzero"
      />
    </svg>
  )
}

export default CustomerAdviser
